"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSystem = void 0;
/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
var EntityManager_1 = require("./EntityManager");
var BaseSystem = /** @class */ (function () {
    function BaseSystem() {
        this.entityManager = EntityManager_1.EntityManager.instance;
        this.enabled = true;
    }
    BaseSystem.prototype.onCreate = function (deltaTime) { };
    BaseSystem.prototype.onUpdate = function (deltaTime) { };
    BaseSystem.prototype.onDestroy = function (deltaTime) { };
    BaseSystem.prototype.onRender = function (deltaTime) { };
    return BaseSystem;
}());
exports.BaseSystem = BaseSystem;
